<template>
  <validation-observer
    ref="form"
    #default="{ invalid }"
  >
    <b-modal
      :id="modalName"
      size="lg"
      ok-only
      :ok-title="$t('save')"
      :ok-disabled="submitSpinner || invalid"
      no-close-on-backdrop
      @ok="onSubmit"
      @hidden="hideModal"
    >
      <template #modal-title="{}">
        <span>
          {{ isUpdated ? $t("Update") : $t("Create") }}
        </span>
      </template>
      <b-form>
        <b-row>
          <b-col
            cols="12"
          >
            <b-form-group
              :label="$t('Question')"
            >
              <validation-provider
                #default="{ errors }"
                :name="$t('Question')"
                vid="question"
                rules="required"
              >
                <b-form-textarea
                  id="question"
                  v-model="form.question"
                  :state="errors.length > 0 ? false : null"
                  :placeholder="$t('Description')"
                />
                <small class="text-danger">{{ errors[0] }}</small>
              </validation-provider>
            </b-form-group>
          </b-col>
          <b-col
            cols="12"
          >
            <b-form-group
              :label="$t('Answer')"
            >
              <validation-provider
                #default="{ errors }"
                :name="$t('Answer')"
                vid="answer"
                rules="required"
              >
                <b-form-textarea
                  id="answer"
                  v-model="form.answer"
                  :state="errors.length > 0 ? false : null"
                  :placeholder="$t('Answer')"
                />
                <small class="text-danger">{{ errors[0] }}</small>
              </validation-provider>
            </b-form-group>
          </b-col>
        </b-row>

      </b-form>
      <template #modal-ok="{}">
        <span>
          <b-spinner
            v-if="submitSpinner"
            small
          />
          {{ $t("save") }}
        </span>
      </template>
    </b-modal>
  </validation-observer>
</template>

<script>
import { EditFormLayoutMixin, EditModalMixin } from '../../../common/mixins/form'

export default {
  name: 'FaqsEditModal',
  mixins: [EditFormLayoutMixin, EditModalMixin],
  data() {
    return {
      routeName: 'faqs',
      modalName: 'modal-faqs-edit',
      createAbleFields: [
        'question',
        'answer',
      ],
    }
  },
}
</script>

<style scoped>

</style>
